import { render, staticRenderFns } from "./ClientUpdateAvailable.vue?vue&type=template&id=40370c73"
import script from "./ClientUpdateAvailable.vue?vue&type=script&lang=ts"
export * from "./ClientUpdateAvailable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports